module.exports = __webpack_public_path__ + "static/media/nishant_badgujar.f0fb29f1.jpg";